export default function apiCall({ url, method, body }) {
    return fetch(url, {
        method,
        headers: new Headers({
            'content-type': 'application/json',
        }),
        body,
    }).then(res => res.json());
}
